const createListReducer = (initialState, handlers) => {
  const handlersObject = {};
  const addHandler = (code, func) => {
    if (!handlersObject[code]) {
      handlersObject[code] = [];
    }
    handlersObject[code].push(func);
  };

  const executeHandlers = (state, action) => {
    let newState = { ...state };
    if (handlersObject[action.type]) {
      handlersObject[action.type].forEach((handler) => {
        newState = handler(newState, action);
      });
    }
    return newState;
  };



  handlers.forEach((handler) => {
    Object.keys(handler).forEach((key) => {
      addHandler(key, handler[key]);
    });
  });

  return (state = initialState, action) => {
    return executeHandlers(state, action);
  };

};

export default createListReducer;
